import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-aria-components";
import {
  createBrowserRouter,
  RouterProvider as DataRouterProvider,
  useHref,
  useNavigate,
} from "react-router-dom";
import { routes } from "./router";
import { initFbPixel } from "./lib/fbpixel";
import { initCapiClient } from "./lib/capiClient";
import "./styles.css";

initFbPixel();
// Kick Meta's client-side param builder so fbp/fbc/IP are ready for the
// first /api/capi POST. Fire-and-forget — never blocks render.
void initCapiClient();

const router = createBrowserRouter(routes);

/**
 * Bridge react-router into react-aria-components so all RAC <Link>/<Button>
 * elements honor client-side navigation + accessibility semantics in one go.
 */
function AppShell() {
  const navigate = useNavigate();
  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      <DataRouterProvider router={router} />
    </RouterProvider>
  );
}

// We have to render the data router *first* to get a navigate function in
// scope — RouterProvider needs it. The cleanest pattern is to mount the data
// router and pull RAC's RouterProvider in inside the first route element. So
// instead we just do this: mount the data router directly. RAC components
// fall back to standard browser nav if the bridge isn't present, which is
// fine for our use case (every nav is full-route).
const container = document.getElementById("root");
if (!container) throw new Error("missing #root");
createRoot(container).render(
  <React.StrictMode>
    <DataRouterProvider router={router} />
  </React.StrictMode>
);

// AppShell retained for reference / future RAC link integration:
void AppShell;
